import { createContext } from 'react';
import { VisionAwarePageData } from '../model/visionaware';

const idleConst: "idle" | "success" | "failed" | "error" = "idle";
const defaultVisionAwareData = {
    status: idleConst,
    data: undefined, 
    error: null, 
    isFetching: false,
    timeRange: 7
}

export const VisionAwareContext = createContext<VisionAwarePageData>( defaultVisionAwareData  );